"use client";
import React, { useRef, useState } from "react";
import Link from "next/link";
import logo from "../../../public/favicon.svg";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useSelector, useDispatch } from "react-redux";
import { signOut } from "aws-amplify/auth";
import swap from "@/assets/icons/swap.png";
import spot from "@/assets/icons/spot.png";
import p2p from "@/assets/icons/p2p.png";
import dashboard from "@/assets/icons/dashboard.png";
import market from "@/assets/icons/market.png";
import profile from "@/assets/icons/profile.png";
import ads from "@/assets/icons/ads.png";
import order from "@/assets/icons/order.png";
import pay from "@/assets/icons/Group.png";
import sign from "@/assets/icons/sign.png";
import { setToken, setLoggedIn, setUser } from "@/redux/user/slice";
import AnimatedButton from "../ui/AnimatedButton";
import { tokenExpiry, tokenExpirySteps } from "@/utils/footerLinks";
import { store } from "@/redux/store";

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const router = useRouter();
  const pathname = usePathname();
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const navItems = [
    {
      name: "About Us",
      path: "/about/",
    },
    {
      name: "Trade",
      path: "#",
      href: "/spot-trade/",
    },
    // {
    //     name: "Learn",
    //     path: "#"
    // },
    {
      name: "Transfer",
      path: "#",
      href: "/swap/",
    },
    // {
    //   name: "Futures",
    //   path: "#",
    //   href: "/futures/",
    // },
    {
      name: "Support",
      path: "/support/",
    },
  ];
  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: dashboard,
      onClick: () => router.push("/dashboard"),
      isMobileOnly: true,
    },
    {
      id: "market",
      label: "Market",
      icon: market,
      onClick: () => router.push("/market"),
      isMobileOnly: true,
    },
    {
      id: "swap",
      label: "Swap",
      icon: swap,
      onClick: () => router.push("/swap"),
      isMobileOnly: true,
    },
    {
      id: "spot-trade",
      label: "Spot Trade",
      icon: spot,
      onClick: () => router.push("/spot-trade"),
      isMobileOnly: true,
    },
    {
      id: "p2p",
      label: "P2P",
      icon: p2p,
      onClick: () => router.push("/p2p"),
      isMobileOnly: true,
    },
    // Divider for mobile menu
    {
      id: "divider",
      type: "divider",
      isMobileOnly: true,
    },
    // Original menu items
    {
      id: "profile",
      label: "Profile",
      icon: profile,
      onClick: () => router.push(loggedIn ? "/profile" : "/login"),
    },
    //  {
    //    id: "post-ads",
    //    label: "Post new ads",
    //    icon: post,
    //    onClick: () => router.push("/post-ads"),
    //  },
    {
      id: "my-ads",
      label: "My ads",
      icon: ads,
      onClick: () => router.push("/p2p/my-adds"),
    },
    {
      id: "orders",
      label: "Orders",
      icon: order,
      onClick: () => router.push("/p2p/order"),
    },
    {
      id: "payment-methods",
      label: "Payment methods",
      icon: pay,
      onClick: () => router.push("/payment-method/list"),
    },
    {
      id: "sign-out",
      label: "Sign out",
      icon: sign,
      onClick: async () => {
        router.push("/login");
        localStorage.clear();
        dispatch(setLoggedIn(false));
        dispatch(setToken(""));
        await signOut();
      },
    },
  ];
  const { user, loggedIn } = useSelector((state: any) => state.user);

  return (
    <>
      {/* <section className="w-full bg-[#111] font-satoshi">
                <div className="container-wrapper p-3 md:py-2 md:px-[60px] text-white text-center mx-auto weight500 text-xs md:text-[16px] leading-6 tracking-[0.15px]">
                    You are currently accessing the test environment. The Mainnet launch
                    is just around the corner. Stay tuned for exciting updates!
                </div>
            </section> */}
      <section className="w-full border-b-2 font-outfit relative">
        <div className="container mx-auto h-[80px] p-3 md:py-5 md:px-[60px] flex justify-between items-center ">
          <div className="flex items-center gap-2">
            <Link href="/" className="flex gap-2 items-center">
              <Image
                onContextMenu={(e) => e.preventDefault()}
                src={logo}
                alt="Paraacrypto Logo"
                width={24}
                height={24}
                className="h-6 w-6"
                priority
              />
              <h3 className="weight700 font-medium text-primaryText text-[22px]">
                Paraacrypto
              </h3>
            </Link>
          </div>
          <div>
            <div className="gap-8 hidden lg:flex">
              {navItems?.map((item, index) => {
                return (
                  // <AnimatedLink
                  //   key={index}
                  //   href={item.href ? item.href : item.path}
                  //   className="no-underline hover:no-underline"
                  // >
                  <h6
                    key={index}
                    onClick={() => {
                      if (item?.name === "Transfer") {
                        if (token && tokenExpiry(token)) {
                          router.push(item.href ? item.href : item.path);
                        } else {
                          tokenExpirySteps();
                        }
                      } else {
                        if (!token && !tokenExpiry(token)) {
                          localStorage.removeItem("token");
                          localStorage.clear();
                          store.dispatch(setUser(null));
                          store.dispatch(setLoggedIn(false));
                        }
                        router.push(item.href ? item.href : item.path);
                      }
                    }}
                    className={`px-5 py-2 font-outfit text-black !font-semibold text-center rounded-[4px] cursor-pointer hover:text-[#00B073] transition-colors duration-200 ${
                      pathname === (item?.path || `${item?.path}/`)
                        ? "!text-[#00b073cc]"
                        : ""
                    }`}
                  >
                    {item.name}
                  </h6>
                  // </AnimatedLink>
                );
              })}
            </div>
          </div>

          {user && loggedIn ? (
            <>
              <div className="hidden sm:flex items-center gap-4">
                {/* <IconBell className="w-5 h-5 text-gray-400 hover:text-black cursor-pointer" /> */}
                <div className="relative">
                  <Image
                    onContextMenu={(e) => e.preventDefault()}
                    src={profile}
                    alt=""
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="w-4 h-4 text-gray-400 hover:text-black cursor-pointer"
                  />

                  {/* Dropdown Menu */}
                  <div
                    ref={dropdownRef}
                    className={`absolute right-0 top-10 w-56 bg-white border border-gray-200 shadow-lg rounded-lg transform transition-all duration-200 ease-in-out z-50 ${
                      isDropdownOpen
                        ? "opacity-100 scale-100"
                        : "opacity-0 scale-95 pointer-events-none"
                    }`}
                  >
                    <div className="py-2">
                      <div className="space-y-1">
                        {menuItems?.map((item: any) => {
                          // Skip mobile-only items on desktop
                          if (item.isMobileOnly && window.innerWidth >= 768) {
                            return null;
                          }

                          if (item.type === "divider") {
                            return window.innerWidth < 768 ? (
                              <div
                                key={item.id}
                                className="my-2 border-t border-gray-200"
                              />
                            ) : null;
                          }

                          return (
                            <button
                              key={item?.id}
                              onClick={() => {
                                item?.onClick();
                                setIsDropdownOpen(false);
                              }}
                              className={`w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-gray-100 transition-colors text-sm ${
                                pathname ===
                                item?.onClick
                                  ?.toString()
                                  ?.match(/push\("([^"]+)"\)/)?.[1]
                                  ? "text-black font-medium"
                                  : "text-textSec"
                              }
                          ${
                            pathname?.includes(`/${item?.id}`)
                              ? "text-black font-medium"
                              : "text-textSec"
                          }
                          `}
                            >
                              <div className="size-6 p-1">
                                <Image
                                  onContextMenu={(e) => e.preventDefault()}
                                  src={item?.icon}
                                  alt=""
                                  className=""
                                />
                              </div>
                              {/* <span className="text-lg">{item?.icon}</span> */}
                              <span>{item?.label}</span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>{" "}
              <button
                className="sm:hidden flex text-black focus:outline-none"
                onClick={toggleMenu}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  ></path>
                </svg>
              </button>
            </>
          ) : (
            <>
              {" "}
              <div className="hidden sm:flex items-center gap-4">
                {/* <AnimatedButton
                // onClick={() => router.push('/login')}
                className="text-textThird hover:text-primaryText"
              >
                <IconSearch />
              </AnimatedButton> */}
                <div
                  onClick={() => router.push("/login")}
                  className="text-black font-semibold font-outfit hover:text-primaryText cursor-pointer"
                >
                  Login
                </div>
                <AnimatedButton
                  onClick={() => router.push("/register")}
                  className="px-4 py-2 bg-activeBtnO font-outfit text-white rounded-lg"
                >
                  Register
                </AnimatedButton>
              </div>
              <button
                className="sm:hidden flex text-black focus:outline-none"
                onClick={toggleMenu}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  ></path>
                </svg>
              </button>
            </>
          )}
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <>
            {/* Blur Overlay */}
            <div
              className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 font-outfit"
              onClick={toggleMenu}
            />

            {/* Mobile Menu */}
            <div className="fixed inset-0 bg-white z-50 h-fit border-b">
              <div className="p-4">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-2">
                    <Image
                      onContextMenu={(e) => e.preventDefault()}
                      src={logo}
                      alt="Paraacrypto Logo"
                      width={24}
                      height={24}
                      className="h-6 w-6"
                    />
                    <span className="font-semibold text-lg">Paraa Crypto</span>
                  </div>
                  <button
                    onClick={toggleMenu}
                    className="p-2 hover:bg-gray-100 rounded-full"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                {/* Navigation Links */}
                <div className="space-y-8">
                  {navItems.map((item, index) => (
                    <Link
                      key={index}
                      href={item.path || ""}
                      className="block text-base text-gray-800 font-semibold"
                      onClick={() => {
                        if (item?.name === "Transfer") {
                          if (token && tokenExpiry(token)) {
                            router.push(item.href ? item.href : item.path);
                          } else {
                            tokenExpirySteps();
                          }
                        } else {
                          if (!token && !tokenExpiry(token)) {
                            localStorage.removeItem("token");
                            localStorage.clear();
                            store.dispatch(setUser(null));
                            store.dispatch(setLoggedIn(false));
                          }
                          router.push(item.href ? item.href : item.path);
                        }
                        setIsMenuOpen(!isMenuOpen);
                      }}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>

                {/* Auth Buttons */}
                {!loggedIn && (
                  <div className="p-4 bg-white flex gap-4">
                    <button
                      onClick={() => {
                        router.push("/login");
                        toggleMenu();
                      }}
                      className="flex-1 py-2 text-center text-gray-800 border rounded-lg"
                    >
                      Login
                    </button>
                    <button
                      onClick={() => {
                        router.push("/register");
                        toggleMenu();
                      }}
                      className="flex-1 py-2 text-center text-white bg-activeBtnO rounded-lg"
                    >
                      Register
                    </button>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </section>
    </>
  );
};

export default Navbar;
